import React from 'react'
import PropTypes from 'prop-types'
import Text from "../i18n/Text";
import {CopyableCaseId} from "./CopyableCaseId";

const APP_DEEPLINK_BASE = process.env.REACT_APP_APP_DEEPLINK_BASE

export default function ContinueInApp({caseId, illustrationDark, illustrationLight}) {
    return <>
        {(illustrationLight && illustrationDark) &&
            <div className="col-xxl-4 offset-xxl-0 col-xl-4 offset-xl-0 col-lg-5 offset-lg-0 col-md-6 offset-md-3
            col-sm-6 offset-sm-3 mb-sm-3 col-6 offset-3 mb-3">
                <img id="illustration-light" className="description-illu" src={illustrationLight}
                     alt="" data-test-id="09ea9966-711b"/>
                <img id="illustration-dark" className="description-illu" src={illustrationDark}
                     alt="" data-test-id="09ea9966-711b"/>
            </div>
        }
        <div className="row ">
            <div className="copy-case-id py-3">
                    <span data-test-id="14644b41-1e1c">
                        <Text k="copy.caseId"/><br/>
                    </span>
                <CopyableCaseId caseId={caseId}/>
            </div>
        </div>
        <div className="text-center">
            <a
                className="mt-4 btn btn-primary"
                href={APP_DEEPLINK_BASE + caseId}
                target="_blank"
                rel="noopener noreferrer"
                data-test-id="4f62fefe-e6b4"
            >
                <Text k="common.continueInApp" />
            </a>
        </div>
    </>
}

ContinueInApp.propTypes = {
    caseId: PropTypes.string.isRequired,
    illustrationDark: PropTypes.string.isRequired,
    illustrationLight: PropTypes.string.isRequired,
}